import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiTrayArrowUp, mdiCellphone, mdiShimmer } from "@mdi/js";
import "./smartTemplateIntro.css";
import SmartTemplateBanner from "../../images/smart-template-intro-banner.svg";

const SmartTemplateIntro = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/login");
  };

  return (
    <div className="smart-template-intro">
      {/* Hero Section with Banner Image */}
      <div className="hero-section">
        <img
          src={SmartTemplateBanner}
          alt="Smart Template Banner"
          className="hero-banner-image"
        />
        <div className="hero-gradient-fade"></div>
      </div>

      {/* Main Content Section */}
      <div className="smart-template-intro-content-wrapper">
        <div className="features-and-cta">
          <h2 className="section-title">How Smart Template Works</h2>
          <div className="features">
            <div className="features-grid">
              {/* Create Template Feature */}
              <div className="feature-item">
                <div className="feature-icon">
                  <Icon
                    path={mdiTrayArrowUp}
                    size={1.5}
                    className="icon-primary"
                  />
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">Create Template</h3>
                  <p className="feature-description">
                    Import Spectora XLS files to create templates.
                    <br />
                    The system automatically extracts sections and adds
                    narratives to your library.
                  </p>
                </div>
              </div>

              {/* Using Templates Feature */}
              <div className="feature-item">
                <div className="feature-icon">
                  <Icon
                    path={mdiCellphone}
                    size={1.5}
                    className="icon-primary"
                  />
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">
                    Using Templates in the Mobile App
                  </h3>
                  <p className="feature-description">
                    Choose a template when starting a project.
                    <br />
                    AI will automatically organize your notes into the right
                    sections.
                  </p>
                </div>
              </div>

              {/* AI Narrative Enhancement Feature */}
              <div className="feature-item">
                <div className="feature-icon">
                  <Icon path={mdiShimmer} size={1.5} className="icon-primary" />
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">AI Narrative Enhancement</h3>
                  <p className="feature-description">
                    AI references your narrative library to generate accurate
                    and professional results from your notes and photos.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="cta-section">
          <Button
            variant="primary"
            size="lg"
            className="get-started-btn"
            onClick={handleGetStarted}
          >
            Get Started
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SmartTemplateIntro;
